import React from "react";
const StatsTableItem = () => {
    return (
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <ul className="_stats_main_item_wrap">
                <li className="_stats_main_item">
                    <input type="checkbox" id="check1"
                        className="_stats_main_item_checkbox" />
                    <label for="check1" className="_stats_main_item_check_label">
                        <img src="assets/img/stat1.png" alt=""
                            className="_stats_main_item_img" />
                        <p className="_stats_main_item_title">3D Renders #2435</p>
                    </label>
                </li>
                <li className="_stats_main_item">
                    <span className="_stats_main_item_eth_ic"><svg
                        xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                        fill="none" viewBox="0 0 15 15">
                        <g clip-path="url(#a)">
                            <path fill="#35373E" fill-rule="evenodd"
                                d="M7.323 14.61 3.159 8.474l4.164 2.63 4.164-2.63-4.164 6.136Z"
                                clip-rule="evenodd" />
                            <path fill="#35373E" fill-rule="evenodd"
                                d="M7.323 14.61v-3.507l4.164-2.63-4.164 6.137Zm0-13.806 4.164 7.012-4.164 2.63-4.164-2.63L7.323.804Z"
                                clip-rule="evenodd" />
                            <path fill="#35373E" fill-rule="evenodd"
                                d="m7.323.804 4.164 7.012-4.164 2.63V.804Z"
                                clip-rule="evenodd" />
                            <path fill="#35373E" fill-rule="evenodd"
                                d="m7.323.804 4.164 7.012-4.164-1.972V.804Z"
                                clip-rule="evenodd" />
                            <path fill="#35373E" fill-rule="evenodd"
                                d="m11.487 7.816-4.164 2.63-4.164-2.63 4.164-1.972 4.164 1.972Z"
                                clip-rule="evenodd" />
                        </g>
                        <defs>
                            <clipPath id="a">
                                <path fill="#fff" d="M0 0h13.806v13.806H0z"
                                    transform="translate(.283 .805)" />
                            </clipPath>
                        </defs>
                    </svg>
                    </span>
                    <p className="_stats_main_item_eth_num">1,324.04</p>
                </li>
                <li className="_stats_main_item">
                    <p className="_stats_main_item_name">Jane_cooper</p>
                </li>
                <li className="_stats_main_item">
                    <p className="_stats_main_item_name">Jenny Wilson</p>
                </li>
                <li className="_stats_main_item">
                    <p className="_stats_main_item_number">02</p>
                </li>
                <li className="_stats_main_item">
                    <p className="_stats_main_item_number">2hours ago</p>
                </li>
                <li className="_stats_main_item">
                    <button className="_stats_main_item_more_btn"><svg
                        xmlns="http://www.w3.org/2000/svg" width="26" height="26"
                        fill="none" viewBox="0 0 26 26">
                        <path fill="#797A7E"
                            d="M12.725 3.339a2.088 2.088 0 0 0-2.081 2.082c0 1.145.936 2.082 2.081 2.082a2.088 2.088 0 0 0 2.082-2.082 2.088 2.088 0 0 0-2.082-2.082Zm0 14.573a2.088 2.088 0 0 0-2.081 2.082c0 1.145.936 2.082 2.081 2.082a2.088 2.088 0 0 0 2.082-2.082 2.088 2.088 0 0 0-2.082-2.082Zm0-7.286a2.088 2.088 0 0 0-2.081 2.082c0 1.145.936 2.082 2.081 2.082a2.088 2.088 0 0 0 2.082-2.082 2.088 2.088 0 0 0-2.082-2.082Z" />
                    </svg>
                    </button>
                </li>
            </ul>
        </div>
    )
}

export default StatsTableItem;